

<template>
    <footer class="bg-gray-50 border-t border-gray-100">
        <div class="max-w-7xl px-5 py-2 md:flex md:items-center md:justify-between">
            <div class="flex justify-center gap-x-6 md:order-2">
            </div>
            <p class="text-center text-sm/6 text-gray-600 md:order-1 md:mt-0">&copy; 2025 Inventree, Inc. All rights reserved.</p>
        </div>
    </footer>
</template>

<script setup>


</script>

<style scoped>

</style>